import React, { Component, Fragment } from 'react'
import theme, {whiteLabelData}  from '../../theme'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import packageInfo from "../../../../package.json"

// Material componentss
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';

import i18next, {t} from 'i18next'
import { Trans } from 'react-i18next';

var version = packageInfo.version;

const styles = {
    button: {
      fontSize: 12,
      color: "grey",
    },
    loginButton: {
        width: 95,
    },
    error: {
        color: theme.palette.error.main,
        display: 'flex',
        alignItems: 'flex-end',
        fontSize: 12,
    },
    textForm: {
        [theme.breakpoints.up('xs')]: {
            width: 229,

        },
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
        },
    },

    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    footerGrid: {
      fontSize: 12,
      maxWidth: 420,
      width: '100%',
    },
    selectLang: {
      fontSize: 12,
    }
}

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            inputs: {
                email: '',
                password: '',
            },
            language: i18next.language
        };
    }

    componentDidMount() {
        this.props.deauthenticate();
    }

    componentDidUpdate(prevProps) {
        if (this.props.error && this.state.isLoading) {
            this.setState({ isLoading: false });
        }
    }

    static defaultProps = {
        error: false,
    }

    static propTypes = {
        error: PropTypes.bool,
        classes: PropTypes.objectOf(PropTypes.string).isRequired,
        onLogin: PropTypes.func.isRequired,
        clearError: PropTypes.func.isRequired,
    }

    handleChangeInput = key => event => {
        if (this.props.error) {
            this.props.clearError();
        }
        this.setState(prevState => ({
            inputs: {
                ...prevState.inputs,
                [key]: event.target.value
            }
        }));
    };

    handleLogin = () => {
        this.setState({ isLoading: true });
        const { inputs: {email, password}} = this.state;

        this.props.onLogin(email, password);
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.handleLogin();
    };

    handleLanguageChange = (event) => {
         i18next.changeLanguage(event.target.value)
         this.setState({language: event.target.value})
    }

    render() {
        const { isLoading, inputs: { email, password }} = this.state;
        const { error } = this.props;
        return (
            <Container component="main" maxWidth="md">
                <Grid container justifyContent={"center"}>
                    <Grid item style={{ marginBottom: 50, marginTop:50 }}>
                        <img style={{ width: '100%', maxWidth: '300px' }} src={whiteLabelData.logo} alt="" />
                    </Grid>
                </Grid>
                <Grid container justifyContent={"center"} sx={{display:'flex'}} >
                    <Paper sx={{padding: 5, width: '100%', maxWidth: 420}} >
                        <Grid component="form" onSubmit={this.handleSubmit} container direction="column" justifyContent={"center"} alignItems="center">
                            <Typography style={{ fontSize: 20 }}>
                                {whiteLabelData.name}
                            </Typography>
                            <Grid container justifyContent={"center"} alignItems="center" direction="column">
                                <TextField
                                    InputProps={{
                                        classes: {
                                            underline: styles.textFieldUnerline
                                        },
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        classes: {
                                            root: styles.textFieldFormLabel,
                                            focused: styles.textFieldFocused,
                                        },
                                    }}
                                    error={error}
                                    name={'email'}
                                    type={'email'}
                                    autoComplete="username"
                                    value={email}
                                    label={t('Global.title_email')}
                                    fullWidth={true}
                                    margin="normal"
                                    style={styles.textField}
                                    onChange={this.handleChangeInput('email')}
                                />
                                <TextField
                                    InputProps={{
                                        classes: {
                                            underline: styles.textFieldUnerline
                                        },
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        classes: {
                                            root: styles.textFieldFormLabel,
                                            focused: styles.textFieldFocused,
                                        },
                                    }}
                                    error={error}
                                    name={'password'}
                                    value={password}
                                    autoComplete="current-password"
                                    label={t('Global.title_password')}
                                    margin="normal"
                                    fullWidth={true}
                                    style={styles.textField}
                                    type="password"
                                    helperText={error ? t('Authentication.toast_error') : ''}
                                    onChange={this.handleChangeInput('password')}
                                />
                            </Grid>
                            <Button style={{ color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20, height: 37 }}
                                variant="outlined"
                                fullWidth={true}
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? <CircularProgress size={24} /> : <Trans i18nKey="Authentication.button_signin"></Trans>}
                            </Button>
                            <Grid container justifyContent={"space-between"} sx={{marginTop:7, alignSelf:"center", justifyContent:"space-between"}} style={styles.linkContainer}>
                                <Grid item>
                                    <Link to="/register" style={{ textDecoration: 'none' }}>
                                        <Button
                                            // color="primary"
                                            style={{ color: theme.palette.primary.dark }}
                                        ><Trans i18nKey="Authentication.button_signup"></Trans></Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link to="/pwdforgot" style={{ textDecoration: 'none' }}>
                                        <Button
                                            // color="primary"
                                            style={{ color: theme.palette.primary.dark }}
                                        > <Trans i18nKey="Authentication.button_password_forgot"></Trans></Button>
                                    </Link>
                                </Grid>
                            </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid container justifyContent="center">
                      <div style={styles.footerGrid}>
                          <Grid container spacing={0} justifyContent="space-between">
                            <Grid item xs={3} style={{ marginTop: 20 }}>
                              <Select
                                native
                                disableUnderline
                                variant='standard'
                                labelId={t('ChooseLanguage.button_choose_language')}
                                id="login_language_selectt"
                                value={this.state.language}
                                onChange={this.handleLanguageChange}
                                style={styles.selectLang}
                                sx={{color:"grey", fontSize:12}}
                              >
                                <option value='en'>English</option>
                                <option value='de'>Deutsch</option>
                              </Select>
                            </Grid>
                            <Grid item xs={6} style={{ marginTop: 20 }} align="center">
                              <Button
                                  color="primary"
                                  size="small"
                                  style={styles.button}
                                  href="https://dezentrale-lueftung.com/datenschutzerklaerung/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  sx={{color:"grey", fontSize:12}}
                                  variant="text"
                                >
                                  <Trans i18nKey="Global.title_privacy_statement"></Trans>
                                </Button>
                            </Grid>
                            <Grid item xs={3} style={{ marginTop: 20 }} align="right">
                              <Button
                                color="primary"
                                size="small"
                                style={styles.button}
                                href="https://www.dezentrale-lueftung.com/impressum/"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{color:"grey", fontSize:12}}
                                variant="text"
                              >
                                <Trans i18nKey="Global.title_legal_notice"></Trans>
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center" style={{ marginTop: 10 }}>
                            <Typography style={{ fontSize: 12, color: "grey"}}>
                              v{version}-{process.env.REACT_APP_GIT_NUM_COMMITS}-{process.env.REACT_APP_GIT_HASH}
                            </Typography>
                          </Grid>
                      </div>
                    </Grid>
            </Container>
        )
    }
}

/* export default function Login() {
    return (
      <ThemeProvider theme={}>
        <theLogin></theLogin>
      </ThemeProvider>
    );
  } */

//export default Login = styled(theLogin)(({theme})=> (styles))

//export default Login
//export default Login

export default Login

//export default withStyles(styles)(Login)
/* export default function Login() {
    return <theLogin>Styled div</theLogin>;


  } */
